import React from "react";
import { NavLink } from "react-router-dom";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
import { useMsal } from "@azure/msal-react";
import {
  Avatar
} from "@mui/material";
function Searchnav() {

  const { instance } = useMsal();

  const loggedInEnterpriseId =
    instance.getActiveAccount()?.idTokenClaims?.enterpriseID || "";

  const allowedUsersForContibution = [
    "h.srinivasan",
    "jeevadharani.ramanan",
    "arpita.m.singh",
    "reshmi.haridas.m",
    "varsha.a.tyagi",
    "potnuru.sandeep"
  ];
  return (
    <>
      <header className="searchnav">
        <div className="searchnav-container">

          <div className="searchnav-left">
            <img
              src={process.env.PUBLIC_URL +"/images/Home/Acc_GT_Gradient_RGB-new.png"}
              className="acc-logo"
              alt="Accenture logo"
            />
            <span className="title">
              L&TT
            </span>
            <span className="nav-divider" />
            <span className="nav-title">
              Community of Learning
            </span>
          </div>

          <nav className="searchnav-center">
            <NavLink
              to="/home"
              className="nav-link"
              activeClassName="active"
            >
              Home
            </NavLink>

            <NavLink
              to="/metrics"
              className="nav-link"
              activeClassName="active"
            >
              Metrics
            </NavLink>

            <NavLink
              to="/dashboard"
              className="nav-link"
              activeClassName="active"
            >
              My Dashboard
            </NavLink>

            <NavLink
              to="/hall-of-fame"
              className="nav-link"
              activeClassName="active"
            >
              Hall of Fame
            </NavLink>
            {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                    <NavLink
                      activeClassName="active"
                      className="nav-link"
                      to={`/analytics`}
                    >
                      Analytics
                    </NavLink>
                )}
          </nav>

          <div className="searchnav-right">
            <WelcomeName />
            {/* <img
              src={process.env.PUBLIC_URL +"/images/Avatar.png"}
              className="user-img"
              alt="user avatar"
            /> */}
            <Avatar
              sx={{ width: 32, height: 32}}
            />
          </div>

        </div>
      </header>
    </>
  );
}

export default Searchnav;
